import React from 'react';
import { withStyles, InputLabel, Select, TextField } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";
import FormControl from '@material-ui/core/FormControl';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/pro-solid-svg-icons";

const styles = theme => ({
    note: {
        color: '#A9A9A9',
        fontSize: '10px',
        textAlign: 'left'
    },
    formControl: {
        minWidth: 120,
        width: '100%',
        maxWidth: '100%',
        padding: '2px 4px',
        color: '#CCCCCC'
    },
    chevronIcon: {
        marginLeft: '10px',
        marginTop: '5px',
        color: '#357ebd',
        marginRight: '7px'
    },
    close: {
        width: '100%',
        position: 'relative',
        height: 20,
        display: 'flex',
        alignItems: 'center',
        padding: '0px 5px',
        fontSize: '1rem',
        fontWeight: 700,
        cursor: 'pointer',
        '&:focus': {
            outline: 'none'
        }
    },
    paper: {
        maxHeight: 500,
    },
    searchBarFixed: {
        position: 'sticky',
        top: 0,
        backgroundColor: '#fff',
        zIndex: 10,
        padding: '8px 16px',
    },
    selection: {
        width: '100%',
        padding: '8px 16px',
        fontSize: '0.875rem',
        fontWeight: 'bold',
        cursor: 'pointer',
        backgroundColor: '#f5f5f5',
        '&:hover': {
            backgroundColor: '#e0e0e0'
        },
        display: 'flex',
        alignItems: 'center',
    }
})

class ReactMultipleSelect extends React.Component {
    constructor(props) {
        super(props);
        const { defaultCheckedAll, optionsList } = props;
        this.searchInputRef = React.createRef();
        this.state = {
            open: false,
            searchValue: '',
            value: defaultCheckedAll ? optionsList : [],
            firstRender: true,
            selectAllChecked: defaultCheckedAll === undefined ? false : true,
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.firstRender && prevProps.value.length > 0) {
            this.setState({ firstRender: false });
        }
    }

    handleOpen = (isOpen) => {
        if (!isOpen) {
            this.setState({ searchValue: "" });
        }
        this.setState({
            open: isOpen,
        });
    };

    handleSearchChange = (event) => {
        const searchValue = event.target.value;
        this.setState({ searchValue }, () => {
            if (this.searchInputRef.current) {
                this.searchInputRef.current.focus();
            }
            const { value } = this.state;
            const { optionsList } = this.props;
    
            const filteredOptionsList = optionsList.filter(option =>
                option.label.toLowerCase().includes(searchValue.toLowerCase())
            );

            const allFilteredSelected = filteredOptionsList.every(option =>
                value.some(selected => selected && selected.value === option.value)
            );

            this.setState({ selectAllChecked: allFilteredSelected });
        });
    };

    handleKeyDown = (event) => {
        event.stopPropagation();
    };

    handleSelectChange = (event) => {
        if (event.nativeEvent?.target?.id === 'closeMenu' ||
            (event.nativeEvent?.target?.tagName === 'INPUT' && event.nativeEvent?.target?.type === 'text')
        ) {
            return;
        }
        const { onChange, target, optionsList } = this.props;
        const { value } = this.state;
        
        this.setState({ value: event.target.value });
        onChange(target, event.target.value);

        if(event.target.value.length == optionsList.length) {
            this.setState({selectAllChecked: true})
        } else {
            this.setState({selectAllChecked: false})
        }
    };

    handleSelectAll = (event) => {
        event.stopPropagation();
        const { onChange, target, optionsList } = this.props;
        const { selectAllChecked, searchValue } = this.state;
    
        const filteredOptionsList = optionsList.filter(option =>
            option.label.toLowerCase().includes(searchValue.toLowerCase())
        );
    
        if (selectAllChecked) {
            this.setState({ value: [], selectAllChecked: false });
            onChange(target, []);
        } else {
            this.setState({ value: filteredOptionsList, selectAllChecked: true });
            onChange(target, filteredOptionsList);
        }
    };

    render() {
        const renderValues = (multiple, selected) => {
            let renderString = '';
            const filteredSelected = selected.filter(item => item && item.label);
            if (multiple) {
                renderString = filteredSelected.map(item => item.label).join(', ');
            } else {
                renderString = filteredSelected.length === 1 ? `${filteredSelected[0].label}` : `${filteredSelected.length} selected`;            
            }
            return renderString;
        };

        const { optionsList, valueStateName, onChange, labelText, classes, target, note, renderMultipleValues = true, enabledSearch = false, defaultCheckedAll = false, ...other } = this.props;
        const { open, searchValue, value, selectAllChecked, firstRender } = this.state;

        const filteredOptionsList = optionsList.filter(option =>
            option.label.toLowerCase().includes(searchValue.toLowerCase())
        );

        const MenuProps = {
            getContentAnchorEl: null,
            disableAutoFocusItem: true,
            anchorOrigin: {
                vertical: "bottom",
                horizontal: "left"
            },
            classes: {
                paper: classes.paper
            }
        };

        return (
            <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="demo-simple-select-outlined-label">{defaultCheckedAll && value.length > 0 ? "" : labelText}</InputLabel>
                <Select
                    className={classes.select}
                    IconComponent={(props) => (
                        <div {...props}>
                            <div className={"pull-right"}>
                                <FontAwesomeIcon className={classes.chevronIcon} icon={faChevronDown} />
                            </div>
                        </div>
                    )}
                    displayEmpty={defaultCheckedAll}
                    value={value}
                    name={valueStateName}
                    onChange={this.handleSelectChange}
                    label={defaultCheckedAll && value.length > 0 ? undefined : labelText}
                    multiple
                    renderValue={(selected) => {
                        if (defaultCheckedAll && firstRender) {
                            return optionsList.map(item => item.label).join(', ');
                        } else {
                            return renderValues(renderMultipleValues, selected);
                        }
                    }}                    
                    MenuProps={MenuProps}
                    open={open}
                    onClose={() => this.handleOpen(false)}
                    onOpen={() => this.handleOpen(true)}
                    {...other}
                >
                    <div id='closeMenu' className={classes.close} onClick={(event) => { event.stopPropagation(); this.handleOpen(false) }}>Close</div>
                    {enabledSearch && (
                        <div className={classes.searchBarFixed} onClick={(event) => event.stopPropagation()}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                size="small"
                                placeholder="Search..."
                                value={searchValue}
                                onChange={this.handleSearchChange}
                                onKeyDown={this.handleKeyDown}
                                inputRef={this.searchInputRef}
                            />
                        </div>
                    )}
                    <MenuItem
                        id="selectAllMenu"
                        onClick={this.handleSelectAll}
                        style={{
                            margin: 0,
                            padding: 0,
                            height: 50,
                        }}
                    >
                        <Checkbox
                            checked={selectAllChecked}
                            onClick={this.handleSelectAll}
                            style={{
                                padding: '0 0 0 24px',
                            }}
                        />
                        <ListItemText
                            primary="Select All"
                            onClick={this.handleSelectAll}
                            style={{
                                flex: 1,
                                padding: '12.5px 10px',
                                height: '100%'
                            }}
                        />
                    </MenuItem>
                    {filteredOptionsList?.map((option) => (
                        <MenuItem key={option.value} value={option}>
                            <Checkbox checked={value?.some(filter => filter?.value === option.value)} />
                            {option.multiSelectLogo} <ListItemText primary={option.label} />
                        </MenuItem>
                    ))}
                </Select>
                <span><small className={classes.note}>{note}</small></span>
            </FormControl>
        );
    }
}

export default withStyles(styles)(ReactMultipleSelect);
